import jwtDecode from 'jwt-decode';
import { Nullable } from 'utils/types';

export class JWTToken {
  private decoded: { exp: number; user_id: number };

  constructor(readonly access: string) {
    this.decoded = jwtDecode(access);
  }

  get expirationTimeStamp(): Nullable<number> {
    return this.decoded.exp ? Number(this.decoded.exp) : null;
  }

  get userId(): number {
    return this.decoded.user_id;
  }
}

const exportObject = {
  create: (access: string) => new JWTToken(access),
};

export default exportObject;
